import { useRef } from 'react';
import XTable from 'components/XTable';
import { DatePicker } from 'antd';
import { getStatics } from 'api/checkInChange';
import moment from 'moment';

const ChangeStatistics = () => {
    const xTableRef = useRef();
    const { RangePicker } = DatePicker;
    const queryItems = [
        {
            formItemApis: {
                label: '查询日期',
                help: null,
                name: 'visitDateRange',
            },
            item: <RangePicker format="YYYY-MM-DD" />,
        },
    ];

    const columns = [
        {
            title: '变更类型',
            dataIndex: 'area',
        },
        {
            title: '变更人数',
            dataIndex: 'num',
        },
    ];

    const handelParams = params => {
        const { visitDateRange, ...otherParams } = params;
        let beginDate = '';
        let endDate = '';
        let newParams = otherParams;
        if (visitDateRange && visitDateRange.length) {
            beginDate = moment(visitDateRange[0]).format('YYYY-MM-DD');
            endDate = moment(visitDateRange[1]).format('YYYY-MM-DD');
            newParams = { ...otherParams, beginDate, endDate };
        }
        return newParams;
    };

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                handelParams={handelParams}
                api={getStatics}
                pagination={false}
                ref={xTableRef}
            />
        </div>
    );
};
export default ChangeStatistics;
